export default __webpack_public_path__ + "static/media/tyoturvallisuus.0e63921a.jpeg";